import { InjectionToken } from '@angular/core';

export const FLYOUT_DATA = new InjectionToken<any>('FLYOUT_DATA');